export default __webpack_public_path__ + "static/media/personalizacao.cfe7dba4.svg";